import { Observable } from '@babylonjs/core/Misc/observable';
import * as log from '../../utils/log';
//State Management and Communication Bus for the 3D Scene to React Layer.
const PostMessage = (command, dataPackage = null) => {
    var _a, _b;
    log.debug(`Post Message: ${command}`, dataPackage);
    (_b = (_a = ReactBabylonLink.FrameRef) === null || _a === void 0 ? void 0 : _a.contentWindow) === null || _b === void 0 ? void 0 : _b.postMessage({ source: 'reactLayer', command, package: dataPackage }, '*');
};
function PostMessageStop(command, dataPackage = null) {
    var _a;
    (_a = ReactBabylonLink.StateBus.get('canNavigate')) === null || _a === void 0 ? void 0 : _a.set(false);
    PostMessage(command, dataPackage);
}
export class ReactBabylonLink {
    static GetFrameContentWindowAny() {
        var _a;
        return (_a = ReactBabylonLink.FrameRef) === null || _a === void 0 ? void 0 : _a.contentWindow;
    }
    static SetConnection(routeName, connection) {
        ReactBabylonLink.StateBus.set(routeName, {
            currentState: connection.currentState,
            set: connection.set,
            onChangeDoneObservable: new Observable()
        });
    }
    static RemoveConnection(routeName) {
        ReactBabylonLink.StateBus.delete(routeName);
    }
}
ReactBabylonLink.StateBus = new Map();
// interface IMessage{
//     source: string
//     command: string
//     [key: string]: any
// }
globalThis.addEventListener('message', (message) => {
    var _a, _b, _c;
    if (((_a = message === null || message === void 0 ? void 0 : message.data) === null || _a === void 0 ? void 0 : _a.source) !== 'babylon')
        return;
    log.debug('Babylon link', message.data);
    const _states = ReactBabylonLink.StateBus;
    switch ((_b = message.data) === null || _b === void 0 ? void 0 : _b.command) {
        //setConnection coming in from the Babylon side.
        case 'setConnection':
            (_c = _states.get(message.data.package.routeName)) === null || _c === void 0 ? void 0 : _c.set(message.data.package.value);
            break;
        case 'getCurrentStableState':
            PostMessage('responseCurrentStableState', BabylonResponses.GetCurrentStableState());
            break;
        case 'getCurrentStableConfiguratorState':
            PostMessage('responseCurrentStableConfiguratorState', BabylonResponses.GetCurrentStableState());
            break;
        default:
            log.warn('Unhandled command', message.data.command);
    }
});
class BabylonResponses {
    static GetCurrentStableState() {
        var _a, _b, _c, _d;
        const state = {
            horses: Object.assign({}, (_a = ReactBabylonLink.StateBus.get('currentHorsesState')) === null || _a === void 0 ? void 0 : _a.currentState),
            jockeys: Object.assign({}, (_b = ReactBabylonLink.StateBus.get('currentJockeysState')) === null || _b === void 0 ? void 0 : _b.currentState),
            skins: Object.assign({}, (_c = ReactBabylonLink.StateBus.get('currentSkinsState')) === null || _c === void 0 ? void 0 : _c.currentState),
            configurator: Object.assign({}, (_d = ReactBabylonLink.StateBus.get('currentConfiguratorState')) === null || _d === void 0 ? void 0 : _d.currentState)
        };
        return state;
    }
    static GetCurrentStableConfiguratorState() {
        return BabylonResponses.GetCurrentStableState();
    }
}
export class BabylonActions {
    static StablesGoToHorseView() {
        PostMessageStop('StablesGoToHorseView');
    }
    static StablesNextStall() {
        PostMessageStop('StablesNextStall');
    }
    static StablesPrevStall() {
        PostMessageStop('StablesPrevStall');
    }
    static StablesGoToJockeyView() {
        PostMessageStop('StablesGoToJockeyView');
    }
    static StablesGoToConfiguratorView() {
        PostMessageStop('StablesGoToConfiguratorView');
    }
    static SendCurrentStableStateDirectly() {
        PostMessageStop('responseCurrentStableState', BabylonResponses.GetCurrentStableState());
    }
    static SendCurrentStableConfiguratorStateDirectly(state = { jockeyIndex: -1, jockeySkinIndex: -1, horseSkinIndex: -1 }) {
        const currentState = BabylonResponses.GetCurrentStableState();
        currentState.configurator.jockeyIndex = state.jockeyIndex;
        currentState.configurator.jockeySkinIndex = state.jockeySkinIndex;
        currentState.configurator.horseSkinIndex = state.horseSkinIndex;
        PostMessageStop('responseCurrentStableConfiguratorState', currentState);
    }
    static UpdateSelectedHorseIndex(index) {
        PostMessageStop('UpdateSelectedHorseIndex', { index });
    }
    static UpdatedSelectedJockeyIndex(index) {
        PostMessageStop('UpdatedSelectedJockeyIndex', { index });
    }
    static StablesPlayIntro() {
        PostMessageStop('StablesPlayIntro');
    }
    static RefreshScene() {
        var _a, _b;
        (_b = (_a = ReactBabylonLink.FrameRef) === null || _a === void 0 ? void 0 : _a.contentDocument) === null || _b === void 0 ? void 0 : _b.location.reload();
    }
}
